import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { CountryService } from "../../../services/CountryService";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import { ProjectRegionService } from "../../../services/ProjectRegionService";
import { AddProjectRegionRequest } from "../../../models/request/projectRegion/AddProjectRegionRequest";
import { AddProjectRegionResponse } from "../../../models/response/projectRegion/AddProjectRegionResponse";
import { GetProjectRegionByIdResponse } from "../../../models/response/projectRegion/GetProjectRegionByIdResponse";
import { GetCountryListResponse } from "../../../models/response/country/GetCountryListResponse";

const ProjectRegionAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Proje - Bölge Eşleştirme"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [projectRegionId, setProjectRegionId] = useState<string | undefined>(undefined);
    const [selectedCountry, setSelectedCountry] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCounty, setSelectedCounty] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDistrict, setSelectedDistrict] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedNeighborhood, setSelectedNeighborhood] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedProject, setSelectedProject] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedRegion, setSelectedRegion] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isFarPoint, setIsFarPoint] = useState(false);
    const [description, setDescription] = useState<string | undefined>(undefined);
    const [selectedCarryTypes, setSelectedCarryTypes] = useState<CustomMultiSelectModel[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetProjectRegionByIdResponse = await ProjectRegionService.getProjectRegionById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setProjectRegionId(response.data.projectRegionId);

                if (response.data.countryId && response.data.countryName)
                    setSelectedCountry({ label: response.data.countryName, value: response.data.countryId });

                if (response.data.countyId && response.data.countyName)
                    setSelectedCounty({ label: response.data.countyName, value: response.data.countyId });

                if (response.data.districtId && response.data.districtName)
                    setSelectedDistrict({ label: response.data.districtName, value: response.data.districtId });

                if (response.data.neighborhoodId && response.data.neighborhoodName)
                    setSelectedNeighborhood({ label: response.data.neighborhoodName, value: response.data.neighborhoodId });

                if (response.data.projectId && response.data.projectName)
                    setSelectedProject({ label: response.data.projectName, value: response.data.projectId });

                if (response.data.regionId && response.data.regionName)
                    setSelectedRegion({ label: response.data.regionName, value: response.data.regionId });

                setIsFarPoint(response.data.isFarPoint);

                setSelectedCarryTypes(response.data.projectRegionCarryTypes.map(function (x) {
                    return { label: x.carryTypeName, value: x.carryTypeId }
                }));

                setDescription(response.data.description);
            }
            else {
                var response2: GetCountryListResponse = await CountryService.getCountryList('TR');

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setSelectedCountry({ label: response2.data[0].name, value: response2.data[0].countryId });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveProjectRegion = async () => {
        try {
            if (!selectedProject) {
                toast.error('Boş alan bırakmayınız!')
                return;
            }

            dispatch(storeActivityIndicator(true));

            var obj: AddProjectRegionRequest = {
                projectRegionId: projectRegionId,
                countryId: selectedCountry?.value,
                countyId: selectedCounty?.value,
                description: description,
                districtId: selectedDistrict?.value,
                isFarPoint: isFarPoint,
                neighborhoodId: selectedNeighborhood?.value,
                projectId: selectedProject.value,
                regionId: selectedRegion?.value,
                projectRegionCarryTypeIds: selectedCarryTypes.map(x => x.value)
            }

            var response: AddProjectRegionResponse = await ProjectRegionService.addProjectRegion(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ülke</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCountry}
                                            onChange={(selectedItem) => {
                                                setSelectedCountry(selectedItem);
                                                setSelectedCounty(undefined);
                                                setSelectedDistrict(undefined);
                                                setSelectedNeighborhood(undefined);
                                            }}
                                            onMenuOpen={() => CountryService.getCountryList()}
                                            labelName='name'
                                            valueName='countryId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">İl</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedCounty}
                                            onChange={(selectedItem) => {
                                                setSelectedCounty(selectedItem);
                                                setSelectedDistrict(undefined);
                                                setSelectedNeighborhood(undefined);
                                            }}
                                            onMenuOpen={selectedCountry ? () => ConstantService.getConstantList('COUNTY', selectedCountry.value) : undefined}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">İlçe</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedDistrict}
                                            onChange={(selectedItem) => {
                                                setSelectedDistrict(selectedItem);
                                                setSelectedNeighborhood(undefined);
                                            }}
                                            onMenuOpen={selectedCounty ? () => ConstantService.getConstantList('DISTRICT', selectedCounty.value) : undefined}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className='row mt-5'>
                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Semt"
                                            selectedValue={selectedNeighborhood}
                                            onChange={setSelectedNeighborhood}
                                            onMenuOpen={selectedDistrict ? () => ConstantService.getConstantList('NEIGHBORHOOD', selectedDistrict.value) : undefined}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Proje</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedProject}
                                            onChange={setSelectedProject}
                                            onMenuOpen={() => ConstantService.getConstantList('PROJECT')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Bölge</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedRegion}
                                            onChange={setSelectedRegion}
                                            onMenuOpen={() => ConstantService.getConstantList('REGION')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-2">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Uzak Bölge</label>

                                        <CustomSwitch isActive={isFarPoint} setIsActive={setIsFarPoint} />
                                    </div>

                                    <div className="col-md-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Taşıma Yöntemi</label>

                                        <CustomMultiSelect
                                            selectedValues={selectedCarryTypes}
                                            onChange={setSelectedCarryTypes}
                                            onMenuOpen={() => ConstantService.getConstantList('CARRY_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>

                                        <CustomTextInput value={description} setValue={setDescription} />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveProjectRegion}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default ProjectRegionAdd;